import { AlertColor } from '@mui/material/Alert';
import { createContext, useState } from 'react';

const ALERT_TIME = 5000;
const initialState = {
    text: '',
    type: undefined,
};
interface AlertContextProps {
    text: string;
    type: AlertColor|undefined;
    setAlert: (text: string, type: AlertColor) => void;
}
const AlertContext = createContext<AlertContextProps>({
    ...initialState,
    setAlert: (text: string, type:AlertColor) => { },
});

export const AlertProvider = ({ children }:any) => {
    const [text, setText] = useState('');
    const [type, setType] = useState<AlertColor|undefined>(undefined);

    const setAlert = (text:string, type:AlertColor) => {
        setText(text);
        setType(type);

        setTimeout(() => {
            setText('');
            setType(undefined);
        }, ALERT_TIME);
    };

    return (
        <AlertContext.Provider
            value={{
                text,
                type,
                setAlert,
            }}
        >
            {children}
        </AlertContext.Provider>
    );
};

export default AlertContext;
